const configChart = (title) => ({
  backgroundColor: [
    "rgba(255, 99, 132, 0.5)",
    "rgba(54, 162, 235, 0.5)",
    "rgba(255, 206, 86, 0.5)",
    "rgba(75, 192, 192, 0.5)",
    "rgba(153, 102, 255, 0.5)",
    "rgba(255, 159, 64, 0.5)",
    "rgba(64, 201, 255, 0.5)",
    "rgba(161, 161, 161, 0.5)",
    "rgba(24, 24, 24, 0.5)",
  ],

  borderColor: [
    "rgba(255, 99, 132, 1)",
    "#366feb",
    "rgba(255, 206, 86, 1)",
    "rgba(75, 192, 192, 1)",
    "rgba(153, 102, 255, 1)",
    "rgba(255, 159, 64, 1)",
    "rgb(64, 249, 255)",
    "rgb(97, 97, 97)",
    "rgb(34, 34, 34)",
  ],

  options: {
    plugins: {
      legend: {
        position: "bottom",
      },
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            const data = tooltipItem.dataset.data;

            const total = data.reduce((soma, i) => soma + i);

            return `${tooltipItem.label} ${(
              (tooltipItem.raw / total) *
              100
            ).toFixed(2)}%  (${tooltipItem.raw})`;
          },
        },
      },
      title: {
        display: true,
        text: title,
      },
    },
  },
});

export { configChart };
